function is_auth( ...args: any[] ) {
    return true;
}

export { is_auth };
